<template>
    <button
        type="button"
        :class="buttonClasses"
        :disabled="disabled"
        @click="handleClick"
    >
        <slot></slot>
    </button>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { ButtonVariant } from '@/types/components/base-components.types';

    // ----- props -----
    const props = withDefaults(
        defineProps<{
            variant: ButtonVariant;
            disabled?: boolean;
        }>(),
        {
            disabled: false,
        }
    );

    // ----- emits -----
    const emits = defineEmits<{
        (event: 'click', payload: MouseEvent): void;
    }>();

    // ----- computed -----
    const buttonClasses = computed(() => {
        return ['btn', props.variant ? `btn-${props.variant}` : null];
    });

    // ----- methods -----
    const handleClick = (event: MouseEvent): void => {
        if (props.disabled) return;
        emits('click', event);
    };
</script>
